import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { useHistory } from 'react-router-dom';
import PATH from '../../constants/paths';
import AskQuestion from './AskQuestion';

const styles = {
  wrapper: 'w-full pt-6 sm:pt-8 pb-2 sm:pb-8',
  row: 'w-full flex flex-col gap-4 md:flex-row md:items-center md:justify-between',
  title: 'text-blue text-2xl sm:text-xl font-extrabold font-serif leading-tight md:text-h-md md:leading-[60px]',
  actions: 'w-full flex flex-col gap-3 md:w-auto sm:flex-row items-stretch sm:items-center sm:gap-4',
  askButton:
    'w-full sm:w-44 h-12 bg-blue rounded-3xl border-none text-white text-sm font-bold uppercase cursor-pointer hover:shadow-lg transition-shadow',
  newRequestButton:
    'w-full sm:w-44 h-12 bg-brand-gold rounded-3xl border-none text-white text-sm font-bold uppercase cursor-pointer hover:shadow-lg transition-shadow',
  modalOverlay: 'fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50',
  modalContent: 'bg-white rounded-lg shadow-xl max-w-2xl w-full mx-10 flex flex-col',
  dialogHeader: 'flex flex-col flex-row mx-10 items-start justify-start',
  dialogBody: 'px-6 overflow-y-auto flex-1',
  dialogFooter: 'px-6 border-t border-gray-200 flex justify-end gap-3',
  toastFrame:
    'fixed top-4 right-4 z-[9999] flex items-center gap-3 min-w-[300px] max-w-[650px] px-4 py-3 bg-evergreen text-white rounded-lg shadow-lg animate-fadeIn',
  confirmMessage: 'flex-1 text-md font-medium',
  toastCloseButton: 'flex-shrink-0 p-1 hover:bg-white/20 rounded transition-colors',
};

const CONFIRM = 'Your award payment question has been sent to Successful Futures.';

const AwardPaymentRequestsHeader = ({ showAction = false }: { showAction?: boolean }) => {
  const history = useHistory();
  const [showQuestionForm, setShowQuestionForm] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const navigateToNewRequest = () => {
    history.push(PATH.AWARD_PAYMENT_REQUEST);
  };

  // Auto-hide warning toast after 6 seconds
  useEffect(() => {
    if (showConfirm) {
      const timer = setTimeout(() => {
        setShowConfirm(false);
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [showConfirm]);

  const handleOpenModal = () => {
    setShowQuestionForm(true);
  };

  const handleCloseModal = () => {
    setShowQuestionForm(false);
  };

  const handleShowConfirm = () => {
    setShowConfirm(true);
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
  };

  return (
    <>
      <div className={cn(styles.wrapper)}>
        <div className={cn(styles.row)}>
          <h1 className={cn(styles.title)}>Award Payment Requests</h1>
          {showAction && (
            <div className={cn(styles.actions)}>
              <button type='button' className={cn(styles.askButton)} onClick={handleOpenModal}>
                Ask A Question
              </button>
              <button type='button' className={cn(styles.newRequestButton)} onClick={navigateToNewRequest}>
                + New Request
              </button>
            </div>
          )}
        </div>
      </div>

      {showQuestionForm && (
        <div className={cn(styles.modalOverlay)} aria-labelledby='award-payment-question-modal-title' role='dialog' aria-modal='true'>
          <div className={cn(styles.modalContent)}>
            <div className={cn(styles.dialogHeader)}>
              <h1 id='award-payment-question-modal-title' className={cn(styles.title)}>
                Ask a Question
              </h1>
            </div>
            <div className={cn(styles.dialogBody)} style={{ minHeight: 250 }}>
              <AskQuestion setShowConfirm={handleShowConfirm} handleSaveReturn={handleCloseModal} />
            </div>
            <div className={cn(styles.dialogFooter)}></div>
          </div>
        </div>
      )}
      {showConfirm && (
        <div className={cn(styles.toastFrame)} role='alert' aria-live='assertive'>
          <span className={cn(styles.confirmMessage)}>{CONFIRM}</span>
          <button onClick={handleConfirmClose} className={cn(styles.toastCloseButton)} aria-label='close'>
            <svg className='w-3 h-3' fill='none' stroke='currentColor' viewBox='0 0 21 21'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' />
            </svg>
          </button>
        </div>
      )}
    </>
  );
};

export default AwardPaymentRequestsHeader;
